import VideoGrid from "@/components/editor/shared/media/video-grid/video-grid-component";
import Benefits from "@/components/editor/shared/sections/benefits/benefits-component";
import RelatedEventsSection from "@/components/editor/themes/hazel/blocks/sections/related-events";
import BrandMaxiCover from "@/components/editor/themes/starter-hub/blocks/covers/brand-maxi-cover/brand-maxi-cover-component";
import HeaderOption2 from "@/components/editor/themes/starter-hub/blocks/covers/header-option-2/header-option-2-component";
import HeaderOption3 from "@/components/editor/themes/starter-hub/blocks/covers/header-option-3/header-option-3-component";
import StandaloneNavigation from "@/components/editor/themes/starter-hub/blocks/covers/standalone-navigation/standalone-navigation-component";
import StandaloneNavigationList from "@/components/editor/themes/starter-hub/blocks/covers/standalone-navigation/standalone-navigation-settings";
import VRHeader from "@/components/editor/themes/starter-hub/blocks/covers/vr-header/vr-header-component";
import BoothCard from "@/components/editor/themes/starter-hub/blocks/expo/booth-card/booth-card-component";
import Booths from "@/components/editor/themes/starter-hub/blocks/expo/booths/booths-component";
import BoothsList from "@/components/editor/themes/starter-hub/blocks/expo/booths/booths-list-component";
import SyncedBooths from "@/components/editor/themes/starter-hub/blocks/expo/booths/synced-booths-component";
import VideoWithParagraph from "@/components/editor/themes/starter-hub/blocks/media/video-with-paragraph/video-with-paragraph-component";
import VideoWithParagraphList from "@/components/editor/themes/starter-hub/blocks/media/video-with-paragraph/video-with-paragraph-list-component";
import VideoWithTitle from "@/components/editor/themes/starter-hub/blocks/media/video-with-title/video-with-title-component";
import DefaultSchedule from "@/components/editor/themes/starter-hub/blocks/schedules/default-schedule/default-schedule-component";
import SyncedDefaultSchedule from "@/components/editor/themes/starter-hub/blocks/schedules/default-schedule/synced-default-schedule-component";
import AboutDetails from "@/components/editor/themes/starter-hub/blocks/sections/about-details/about-details-component";
import AboutDetailsItem from "@/components/editor/themes/starter-hub/blocks/sections/about-details/about-details-item";
import AboutDetailsList from "@/components/editor/themes/starter-hub/blocks/sections/about-details/about-details-list-component";
import AboutSummary from "@/components/editor/themes/starter-hub/blocks/sections/about-summary/about-summary-component";
import BenefitCard from "@/components/editor/themes/starter-hub/blocks/sections/benefits/benefit-card/benefit-card-component";
import Divider from "@/components/editor/themes/starter-hub/blocks/sections/divider/divider-component";
import Gallery from "@/components/editor/themes/starter-hub/blocks/sections/gallery";
import ParagraphItem from "@/components/editor/themes/starter-hub/blocks/sections/paragraph-picture/paragraph-item-component";
import ParagraphPicture from "@/components/editor/themes/starter-hub/blocks/sections/paragraph-picture/paragraph-picture-component";
import ParagraphPictureList from "@/components/editor/themes/starter-hub/blocks/sections/paragraph-picture/paragraph-picture-list-component";
import RichTextSection from "@/components/editor/themes/starter-hub/blocks/sections/rich-text-section/rich-text-section-component";
import SpeakerCard from "@/components/editor/themes/starter-hub/blocks/speakers/speaker-card/speaker-card-component";
import SyncedSpeakerCard from "@/components/editor/themes/starter-hub/blocks/speakers/speaker-card/synced-speaker-card-component";
import Speakers from "@/components/editor/themes/starter-hub/blocks/speakers/speakers-component";
import SpeakersList from "@/components/editor/themes/starter-hub/blocks/speakers/speakers-list-component";
import SyncedSpeakers from "@/components/editor/themes/starter-hub/blocks/speakers/synced-speakers-component";
import SponsorsCard from "@/components/editor/themes/starter-hub/blocks/sponsors/sponsor-card/sponsor-card-component";
import Sponsors from "@/components/editor/themes/starter-hub/blocks/sponsors/sponsors-component";
import SponsorsList from "@/components/editor/themes/starter-hub/blocks/sponsors/sponsors-list-component";
import SyncedSponsors from "@/components/editor/themes/starter-hub/blocks/sponsors/synced-sponsors-component";

const SponsorCard = SponsorsCard;

const blocks = {
  AboutDetails,
  AboutDetailsItem,
  AboutDetailsList,
  AboutSummary,
  BenefitCard,
  Benefits,
  BoothCard,
  Booths,
  BoothsList,
  BrandMaxiCover,
  DefaultSchedule,
  Divider,
  Gallery,
  HeaderOption2,
  HeaderOption3,
  ParagraphItem,
  ParagraphPicture,
  ParagraphPictureList,
  RelatedEventsSection,
  RichTextSection,
  SpeakerCard,
  Speakers,
  SpeakersList,
  SponsorCard,
  Sponsors,
  SponsorsCard,
  SponsorsList,
  StandaloneNavigation,
  StandaloneNavigationList,
  SyncedBooths,
  SyncedDefaultSchedule,
  SyncedSpeakerCard,
  SyncedSpeakers,
  SyncedSponsors,
  VideoGrid,
  VideoWithParagraph,
  VideoWithParagraphList,
  VideoWithTitle,
  VRHeader,
};

export const SELDON_NONSELECTABLE_BLOCKS: React.ReactNode[] = [
  blocks.SponsorsList.name,
  blocks.SpeakersList.name,
  blocks.BoothsList.name,
  blocks.AboutDetailsList.name,
  blocks.ParagraphPictureList.name,
  blocks.VideoWithParagraphList.name,
];

export default blocks;
